import { describeCells, FreecellBoard } from '../components/FreecellBoard.js';
import { useStore } from '../store.js';
import { SoloRoom } from './SoloRoom.js';

/** FreeCell at the table: the shared patience screen, wearing its board. */
export function FreecellRoom() {
  const view = useStore((s) => s.freecell);

  if (!view) {
    return (
      <main className="game">
        <p className="game__loading">Dealing…</p>
      </main>
    );
  }

  return (
    <SoloRoom
      name="FreeCell"
      phase={view.phase}
      moveNumber={view.moveNumber}
      status={describeCells(view.cellsFree, view.maxMoveSize)}
      board={<FreecellBoard />}
      stuckTitle="Nothing will move"
      // No hedging about the shuffle here, unlike Klondike: every card was face
      // up from the start, so a dead FreeCell deal is a position the player
      // played themselves into.
      stuckBody="Every cell is full and no card on the board will stack. Nothing was hidden — that one got away."
    />
  );
}
